export default __webpack_public_path__ + "static/news_1400-58ecf68b03e661ebbe4e2965ee194378.jpg";